<template>
  <div>
    <input type="file" ref="file" class="hidden" @input="onFileUpload" />
    <button
      class="flex items-center"
      aria-label="Upload media"
      type="button"
      @click="$refs.file.click()"
    >
      <svg-vue
        icon="photo-film-solid"
        title="Upload Media"
        :class="`${height} ${width} ${fill}`"
      />
      <span
        class="ml-3"
        v-if="text"
      >{{ text }}</span>
    </button>
  </div>

</template>

<script>
export default {
    props: ['heightClass', 'widthClass', 'fillClass', 'text'],
    methods: {
        onFileUpload(event) {
            this.$emit('onFileUpload', event);
        },
    },
    computed: {
        height() {
            return this.heightClass ? this.heightClass : 'h-9';
        },
        width() {
            return this.widthClass ? this.widthClass : 'w-9';
        },
        fill() {
            return this.fillClass ? this.fillClass : 'fill-salesium-red';
        },
    },
};
</script>
